import service from '@/utils/server';

const modName='/md/plantToxin/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const update = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

export const add = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

export const edit = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};

export const getDetailById = data => {
  return service({
    url: modName + 'getDetailById/'+data,
    method: 'post',
  });
};



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/plantToxin/api/index.js